<cc-data-grid-features [stateConfig]="{ storageKey: storageKey, storeGroupings: true }" [dataSource]="gridSource">
    <dx-data-grid
        #boardApprovalGrid
        appHasInternalUserColumns
        width="100%"
        height="100%"
        [dataSource]="gridSource"
        (onSelectionChanged)="onApprovalRowSelection($event)"
        (onRowPrepared)="onGridRowPrepared($event)"
        (onCellPrepared)="onCellPrepared($event)"
        (onContentReady)="onGridContentReady()"
    >
        <ng-container *ngIf="mode === 'OPEN' && isRowsSelectable">
            <dxo-selection showCheckBoxesMode="always" mode="multiple"></dxo-selection>
        </ng-container>
        <dxo-grouping [autoExpandAll]="!isInternalUser"></dxo-grouping>

        <!-- NOTE:
            Files column is intenionally removed as there is no data available
            Agreed with Deepali M and Eram on 28th Sept 2022.
        -->
        <dxi-column
            type="buttons"
            caption="Action"
            alignment="center"
            [width]="110"
            [visibleIndex]="0"
            [showInColumnChooser]="false"
            [allowFiltering]="false"
            [allowHeaderFiltering]="false"
            [allowGrouping]="false"
            [allowSorting]="false"
        >
            <dxi-button template="template">
                <div *dxTemplate="let t of 'template'" class="cc-action-button">
                    <dx-button
                        type="normal"
                        text="Action"
                        hint="Action"
                        [icon]="iconRunnerBlue"
                        [visible]="t.data.allowAction === true"
                        (onClick)="onActionClick(t.data)"
                    ></dx-button>
                    <dx-button
                        type="normal"
                        text="View"
                        hint="View"
                        [icon]="iconEyeBlue"
                        [visible]="t.data.allowAction === false"
                        (onClick)="onViewClick(t.data)"
                    ></dx-button>
                </div>
            </dxi-button>
        </dxi-column>
        <dxi-column
            dataField="process"
            dataType="string"
            caption="Process"
            [groupIndex]="0"
            groupCellTemplate="groupProcessCellTemplate"
        ></dxi-column>
        <dxi-column
            dataField="processIdDisplayText"
            dataType="string"
            caption="ID"
            [groupIndex]="1"
            groupCellTemplate="groupProcessIdCellTemplate"
        ></dxi-column>
        <dxi-column dataField="community" dataType="string" caption="Community"></dxi-column>
        <dxi-column
            dataField="userNameDisplayText"
            dataType="string"
            caption="User"
            cellTemplate="userNameDisplayCellTemplate"
        ></dxi-column>
        <dxi-column dataField="addedOn" dataType="date" caption="Added On" [format]="dateFormat"></dxi-column>
        <dxi-column dataField="dueDate" dataType="date" caption="Due Date" [format]="dateFormat"></dxi-column>
        <dxi-column
            dataField="daysRemaining"
            dataType="number"
            caption="Days Remaining"
            cellTemplate="daysRemainingCellTemplate"
            [visible]="mode === 'OPEN'"
        ></dxi-column>
        <dxi-column
            dataField="statusIndicator"
            dataType="string"
            caption="Info"
            alignment="center"
            cellTemplate="statusIndicatorCellTemplate"
        ></dxi-column>
        <dxi-column dataField="status" dataType="string" caption="Status"></dxi-column>
        <dxi-column
            dataField="documentCount"
            dataType="number"
            caption="Documents"
            alignment="center"
            cellTemplate="documentCellTemplate"
            [allowGrouping]="false"
        ></dxi-column>
        <dxi-column
            dataField="hasNotesDisplayText"
            dataType="string"
            caption="Discussion Notes"
            alignment="center"
            cellTemplate="notesCellTemplate"
            [width]="100"
            [allowGrouping]="false"
        ></dxi-column>
        <dxi-column
            caption="Log"
            alignment="center"
            cellTemplate="logCellTemplate"
            [allowGrouping]="false"
        ></dxi-column>
        <dxi-column
            dataField="requiredDisplayText"
            dataType="string"
            caption="Required"
            alignment="center"
            cellTemplate="booleanValueCellTemplate"
            [width]="85"
            [allowGrouping]="false"
        ></dxi-column>
        <dxi-column dataField="reference" dataType="string" caption="Reference"></dxi-column>
        <dxi-column
            caption="Details"
            alignment="center"
            cellTemplate="detailsCellTemplate"
            [allowGrouping]="false"
        ></dxi-column>

        <div *dxTemplate="let data of 'userNameDisplayCellTemplate'">
            <app-user-bio-link [user]="data.data.userInfo" [communityId]="data.data.communityId"></app-user-bio-link>
        </div>
        <div *dxTemplate="let data of 'statusIndicatorCellTemplate'">
            <ng-container *ngIf="data.value === 'RED_CROSS'">
                <i class="cc-1-5x cc-icon-cross" [ngClass]="iconCross"></i>
            </ng-container>
            <ng-container *ngIf="data.value === 'GREEN_FLAG'">
                <i class="cc-1-5x cc-icon-check" [ngClass]="iconFlag"></i>
            </ng-container>
            <ng-container *ngIf="data.value === 'GREEN_CHECK'">
                <i class="cc-1-5x cc-icon-check" [ngClass]="iconCheck"></i>
            </ng-container>
            <ng-container *ngIf="data.value === 'RED_FLAG'">
                <i class="cc-1-5x cc-red-icon" [ngClass]="iconFlag"></i>
            </ng-container>
            <ng-container *ngIf="data.value === 'INFO'">
                <i class="cc-1-5x dx-theme-accent-as-text-color" [ngClass]="iconInfo"></i>
            </ng-container>
            <ng-container *ngIf="data.value === 'WARNING'">
                <i class="cc-1-5x cc-warn-icon" [ngClass]="iconWarn"></i>
            </ng-container>
        </div>

        <div *dxTemplate="let d of 'documentCellTemplate'" (click)="onGridAttachmentClick(d.data)">
            <div class="row-container">
                <i
                    class="dx-theme-accent-as-text-color cell-link-content add-short-padding cc-1-5x"
                    title="Attachments"
                    [ngClass]="iconAttachment"
                ></i>
                <span *ngIf="d.data.documentCount > 0">({{ d.data.documentCount }})</span>
            </div>
        </div>

        <div *dxTemplate="let d of 'notesCellTemplate'" (click)="onGridNotesClick(d.data)">
            <div *ngIf="d.data.hasNotes">
                <i
                    class="cc-1-5x cell-link-content cc-icon-content cc-icon-check"
                    title="Notes"
                    [ngClass]="iconNotes"
                ></i>
            </div>

            <div *ngIf="!d.data.hasNotes">
                <i
                    class="cc-1-5x cell-link-content dx-theme-accent-as-text-color"
                    title="Empty Notes"
                    [ngClass]="iconEmptyNotes"
                ></i>
            </div>
        </div>

        <div *dxTemplate="let t of 'logCellTemplate'">
            <i
                class="cc-1-5x cell-link-content dx-theme-accent-as-text-color"
                title="Logs"
                [ngClass]="iconHistory"
                (click)="onGridHistoryClick(t.data)"
            ></i>
        </div>

        <div *dxTemplate="let data of 'booleanValueCellTemplate'">
            <ng-container *ngIf="data.data.required">
                <i class="cc-1-5x cc-icon-check" title="Required" [ngClass]="iconCheck"></i>
            </ng-container>
        </div>

        <div *dxTemplate="let data of 'detailsCellTemplate'">
            <i
                class="cc-1-5x cell-link-content dx-theme-accent-as-text-color"
                [ngClass]="iconInfo"
                [title]="data.data.detailDisplayText"
                (click)="onGridDetailsClick(data.data)"
            ></i>
        </div>

        <div *dxTemplate="let data of 'daysRemainingCellTemplate'">
            <ng-container *ngIf="!!data.data.daysRemaining">
                <ng-container *ngIf="data.data.daysRemaining < 0">
                    <div class="cc-error-text-color">{{ data.data.daysRemaining * -1 }}&nbsp;days overdue</div>
                </ng-container>
                <ng-container *ngIf="data.data.daysRemaining >= 0">
                    {{ data.data.daysRemaining }} &nbsp;days remaining
                </ng-container>
            </ng-container>
        </div>

        <div *dxTemplate="let data of 'groupProcessCellTemplate'">
            <span class="process-group-items">
                <a
                    href="javascript:void(0)"
                    class="cc-hyperlink"
                    (click)="onHelpKeyClick(data.value, data.data.communityId)"
                >
                    {{ getGroupTemplateTitle(data.value) }}
                    <i class="dx-theme-accent-as-text-color cell-link-content" [ngClass]="iconHelp"></i>
                </a>
                <ng-container *ngIf="queueParams?.communityId">
                    &nbsp; - &nbsp;
                    <a href="javascript:void(0)" class="cc-hyperlink process-group-items">
                        <div (click)="approvalRequireClick(data.value)">Approval Requirement</div>
                        &nbsp;
                        <i
                            class="dx-theme-accent-as-text-color cell-link-content"
                            [ngClass]="iconHelp"
                            (click)="approvalRequireClick(data.value)"
                        ></i>
                    </a>
                </ng-container>
                &nbsp;
                <span>Count({{ getCount(data) }})</span>
            </span>
        </div>

        <div *dxTemplate="let data of 'groupProcessIdCellTemplate'">
            <div
                *ngIf="!!data.data"
                class="normal-text cc-text-color"
                [innerHTML]="getProcessIdGroupTemplateTitle(data.data)"
            ></div>
        </div>

        <dxo-summary>
            <dxi-group-item
                column="process"
                summaryType="count"
                displayFormat="Count = {0}"
                [skipEmptyValues]="true"
            ></dxi-group-item>
            <dxi-group-item
                column="processIdDisplayText"
                summaryType="count"
                displayFormat="Count = {0}"
                [skipEmptyValues]="true"
            ></dxi-group-item>
        </dxo-summary>
    </dx-data-grid>
</cc-data-grid-features>

<app-board-approval-editor
    *ngIf="showEditor"
    [visible]="showEditor"
    [isClosed]="queueParams.isClosedQueue"
    [selectedRequest]="selectedRequest"
    [mode]="mode"
    (onClose)="onEditorClose($event)"
></app-board-approval-editor>

<app-board-approval-grid-notes-editor
    *ngIf="showGridNotes"
    [visible]="showGridNotes"
    [isClosed]="queueParams?.isClosedQueue"
    [selectedRequest]="selectedRequest"
    (onNotesEditorClose)="onNotesEditorClose($event)"
></app-board-approval-grid-notes-editor>

<app-collection-referral-detail
    *ngIf="showCollectionReferral"
    [visible]="showCollectionReferral"
    [processId]="selectedRequest?.processId"
    [processText]="selectedRequest?.processIdDisplayText"
    [communityId]="selectedRequest?.communityId"
    [collectionsDetail]="collectionsDetail"
    [mode]="mode"
    (onClose)="showCollectionReferral = false"
></app-collection-referral-detail>

<app-architectural-application-editor
    *ngIf="showAccEditor"
    [visible]="showAccEditor"
    [popupTitle]="accEditorTitle"
    [communityId]="boardApprovalParam.communityId"
    [accItemId]="boardApprovalParam.accItemId"
    [customerId]="boardApprovalParam.customerId"
    (closeApplicationEditorPopup)="onAccEditorClose($event)"
></app-architectural-application-editor>

<app-architectural-application-viewer
    *ngIf="showAccDetail"
    [visible]="showAccDetail"
    [popupTitle]="accEditorTitle"
    [accDetailParam]="boardApprovalParam"
    (closeApplicationEditorPopup)="showAccDetail = false"
></app-architectural-application-viewer>

<app-workflow-viewer
    *ngIf="showWorkflowViewer"
    [viewOnly]="true"
    [workflowId]="selectedRequest?.processId"
    [communityId]="selectedRequest?.communityId"
    (onClose)="showWorkflowViewer = false"
></app-workflow-viewer>

<app-architectural-application-attachment-editor
    *ngIf="showAccAttachments"
    [visible]="showAccAttachments"
    [docParam]="boardApprovalParam"
    [communityId]="selectedRequest?.communityId"
    [customerId]="selectedRequest?.customerId"
    (onClose)="onAccAttachmentEditorClose($event)"
></app-architectural-application-attachment-editor>

<app-architectural-application-transaction-log
    *ngIf="showAccTransactionLog"
    [visible]="showAccTransactionLog"
    [title]="popupTitle"
    [transactionLogResultData]="transactionLogResultData"
    (onTransactionLogClose)="showAccTransactionLog = false"
></app-architectural-application-transaction-log>

<app-workflow-board-history
    *ngIf="showWorkFlowTransactionLog"
    [workflowId]="boardApprovalParam?.workflowId"
    [communityId]="boardApprovalParam?.communityId"
    (onClose)="showWorkFlowTransactionLog = false"
></app-workflow-board-history>

<dx-popup
    *ngIf="showCollectionTransactionLog"
    width="60%"
    height="70%"
    [title]="popupTitle"
    [showTitle]="true"
    [resizeEnabled]="true"
    [visible]="showCollectionTransactionLog"
    (onHidden)="showCollectionTransactionLog = false"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <iframe
                        *ngIf="showCollectionTransactionLog"
                        width="100%"
                        height="100%"
                        class="cc-iframe"
                        [title]="popupTitle"
                        [src]="collectionLogUrl | ccSafeUrl"
                    ></iframe>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Close"
                                    hint="Close"
                                    [icon]="iconCancel"
                                    (onClick)="showCollectionTransactionLog = false"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<app-collections-attachment-selector
    *ngIf="showCollectionAttachment"
    [title]="popupTitle"
    [communityId]="selectedRequest?.communityId"
    [customerId]="selectedRequest?.customerId"
    [isViewOnly]="selectedRequest?.allowAction !== true"
    [visible]="showCollectionAttachment"
    (onClose)="onCollectionAttachmentClose()"
></app-collections-attachment-selector>

<app-board-approval-rules
    *ngIf="showBoardApprovalPopup"
    [visible]="showBoardApprovalPopup"
    [boardApprovalProcess]="boardApprovalRules"
    (closeBoardApprovalPopup)="showBoardApprovalPopup = false"
></app-board-approval-rules>

<!-- NOTE:
    Change: In v2, option for delete workflow document is removed.
    Agreed with Sandeep and Eram on 27th Sept 2022.
-->

<app-attachment-selector
    *ngIf="showWorkflowAttachment"
    [viewOnly]="true"
    [selectedAttachments]="[workFlowAttachment]"
    (onClose)="onWorkflowAttachmentViewerClose()"
></app-attachment-selector>
